// extracted by mini-css-extract-plugin
export default {"top":"DoubleDirectionalArrow_top__+RWtK","right":"DoubleDirectionalArrow_right__owT1v","down":"DoubleDirectionalArrow_down__9m6n8","left":"DoubleDirectionalArrow_left__uD1nI"};